module.exports = __webpack_public_path__ + "img/qr-code-guangdong.2ed8141a.jpg";